import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { trimStrings } from '@core/helpers';
import { environment } from '@environments/environment';
import { Observable, Subject, catchError, takeUntil, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    private $unsubscribe = new Subject<void>();
    private readonly API_URL = `${environment.apiUrl}/api/`;

    constructor(private http: HttpClient) {}

    get(path: string, params = {}, responseType?: any, observe: 'body' | 'response' = 'body'): Observable<any> {
        const trimmedParams = trimStrings(params);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http
            .get(`${this.API_URL}${trimmedPath}`, {
                params: trimmedParams,
                responseType: responseType ?? undefined,
                observe: observe as any,
            })
            .pipe(
                catchError(error => {
                    console.error(error);
                    if (error.error === 'login_required') {
                        window.location.reload();
                    }
                    return throwError(() => error);
                }),
                takeUntil(this.$unsubscribe)
            );
    }

    put(path: string, body = {}): Observable<any> {
        const trimmedBody = trimStrings(body);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.put(`${this.API_URL}${trimmedPath}`, trimmedBody).pipe(
            catchError(error => {
                console.error(error);
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            }),
            takeUntil(this.$unsubscribe)
        );
    }

    patch(path: string, body = {}): Observable<any> {
        const trimmedBody = trimStrings(body);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.patch(`${this.API_URL}${trimmedPath}`, trimmedBody).pipe(
            catchError(error => {
                console.error(error);
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            }),
            takeUntil(this.$unsubscribe)
        );
    }

    post(path: string, body = {}, params = {}): Observable<any> {
        const trimmedBody = trimStrings(body);
        const trimmedParams = trimStrings(params);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.post(`${this.API_URL}${trimmedPath}`, trimmedBody, { params: trimmedParams }).pipe(
            catchError(error => {
                console.error(error);
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            }),
            takeUntil(this.$unsubscribe)
        );
    }

    delete(path: string): Observable<any> {
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.delete(`${this.API_URL}${trimmedPath}`, {}).pipe(
            catchError(error => {
                console.error(error);
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            }),
            takeUntil(this.$unsubscribe)
        );
    }

    tearDown(): void {
        this.$unsubscribe.next();
    }
}
